import { NgModule } from "@angular/core";
import { RouterModule } from "@angular/router";
import { routes } from "./routes";
import { EcomLegacyRedirectComponent } from "./ecom/ecom-legacy-redirect.guard";

@NgModule({
  declarations: [EcomLegacyRedirectComponent],
  imports: [
    RouterModule.forRoot(routes, {
      onSameUrlNavigation: "reload",
      anchorScrolling: "enabled",
      scrollOffset: [0, 112],
    }),
  ],
  exports: [RouterModule],
})
export class RoutesModule {
  constructor() {}
}